import { DTO__generation_tool } from '@shared/dto/generation/DTO__generation_tool';
import { FIELD__base } from '../../_fields/_base/FIELD__base';
import { ENUM__image_asset_category } from '../../_fields/ENUM__image_asset_category';
import { DTO_GRAPH__instance } from '../../_graph/DTO_GRAPH__instance';
import { INVOCATION_GRID2D__view } from '../../_invocations/grid2d/INVOCATION_GRID2D__view';
import { INVOCATION_IMAGE__viewport } from '../../_invocations/image/INVOCATION_IMAGE__viewport';
import { ENUM__graph_template_name } from '../sd_1/ENUM__graph_template_name';

export function GENERATION_TOOL__general__image_aspect_ratio(category: ENUM__image_asset_category) {
  let out = new DTO__generation_tool();
  out.name = ENUM__graph_template_name.OUTPUT_ASPECT_RATIO;

  let graph = DTO_GRAPH__instance.CREATE_NEW();
  out.graph = graph;

  /*
   *
   */
  let node__grid2d = INVOCATION_GRID2D__view.create_node_for(graph);
  /*
   *
   */
  let node__viewport_image_preview = INVOCATION_IMAGE__viewport.create_node_for(graph);

  /*
   *
   */

  let node__viewport_category = INVOCATION_IMAGE__viewport.create_node_for(graph);
  node__viewport_category.store__disable();
  node__viewport_category.clear_field_roles();

  node__viewport_category.set_category(category);

  graph.edge__try_add_for_fields(node__viewport_category.out__image_cropped, node__grid2d.image);

  /*
   * VIEW
   */
  let fields__visible: FIELD__base[] = [
    node__grid2d.cell__aspect_ratio_reference,
    node__grid2d.cell__aspect_ratio_width,
    node__grid2d.cell__aspect_ratio_height,
    node__viewport_image_preview.image,
  ];

  out.view__add({ fields__visible, fields__stored: fields__visible });

  /*
   *
   */

  return out;
}
